import { Divider } from '@mui/material'
import React, { useMemo } from 'react'

const Detail = ({ movie }) => {
  const genres = movie?.genres?.map(genre => genre?.name)
  
  const TagList = ({ items, className = "" }) => {
    return (
      <div className={`flex gap-2 flex-wrap ${className}`}>
        {items?.map((item) => (
          <p
            key={item}
            className="border px-3 py-1 rounded-lg text-sm font-medium"
          >
            {item}
          </p>
        ))}
      </div>
    );
  };
const images = useMemo(() => {
  if (movie?.media_type === "Series" && Array.isArray(movie?.seasons)) {
    const lastSeason = movie.seasons[movie.seasons.length - 1];
    return {
      backdrop: lastSeason?.backdrop,
      poster: lastSeason?.poster,
    };
  }
  return {
    backdrop: movie?.backdrop,
    poster: movie?.poster,
  };
}, [movie]);

  return (
    <div>
      <p class="font-extrabold text-2xl text-gray-600 ">
        Description
      </p>
      <p class="text-justify text-base font-extralight">
        {movie?.description}
      </p>
      <Divider sx={{ mt: 2, mb: 4 }} />
      <p class="font-black text-2xl text-gray-600">
        Basic info
      </p>
      <div className='flex flex-wrap gap-5 text-gray-800'>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Type</p>
          <p className='text-lg'>{movie?.media_type}</p>
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Country</p>
          <p className='text-lg'>{movie?.country?.name}</p>
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Duration</p>
          <p className='text-lg'>{movie?.duration || "N/A"}</p>
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Language</p>
          <p className='text-lg'>{movie?.language?.name}</p>
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Released</p>
          <p className='text-lg'>{movie?.release_year}</p>
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Classification</p>
          <TagList items={movie?.classifications?.map(classification => classification?.name)} />
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Category</p>
          <TagList items={genres} />
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5 border-dashed border-b'>
          <p className='text-sm !font-extrabold'>Director</p>
          <p className='text-lg'>{movie?.director || 'N/A'}</p>
        </div>
        <div className='flex flex-col gap-2 flex-[45%] py-5'>
          <p className='text-2xl !font-black '>Cast</p>
          <TagList items={movie?.cast?.map(cast => cast?.name)} />
        </div>
      </div>
      <div className='flex flex-col gap-2 flex-[45%] py-5'>
        <p className='text-2xl !font-black '>Movie cover</p>
        <div className='flex gap-4'>
          <div className=' flex-[63%]'>
            <p className='text-2xl !font-black'>Landscape</p>
            <img src={images?.backdrop|| "https://placehold.co/620x350"} width={'100%'} alt="" className='!h-5/6 !rounded-xl' />
          </div>
          <div className='flex-[33%]'>
            <p className='text-2xl !font-black'>Portrait</p>
            <img src={images?.poster || "https://placehold.co/260x300"} width={'100%'} alt="" className='!h-5/6 !rounded-xl' />
          </div>

        </div>
      </div>



    </div>
  )
}

export default Detail